export default "__VITE_ASSET__CgzAPMvy__"